// The Vue build version to load with the `import` command.
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
// import cssVars from 'css-vars-ponyfill'
import Multiselect from "vue-multiselect";
import Vue from "vue";
import Antd from "ant-design-vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueTagsInput from "@johmun/vue-tags-input";
import VueSweetalert2 from "vue-sweetalert2";
import Vuelidate from "vuelidate";
import App from "./App.vue";
import router from "./router";
import Vuetify from "vuetify";
import { store } from "./store/store";
import Toasted from "vue-toasted";
import VeeValidate from "vee-validate";
import * as VueGoogleMaps from "vue2-google-maps";
import JsonExcel from "vue-json-excel";
import { GOOGLE_MAP_KEY } from "./config/index";
import socketMixin from "@/mixins/socketConnection";
import currentUser from "@/mixins/currentUser";
import exportMixin from "@/mixins/exportCSV";
import VueI18n from "vue-i18n";
import i18nData from "@/i18n/i18nData";
import i18n from "./i18n/i18n";

// Stylesheets
import "ant-design-vue/dist/antd.css";
import "vuetify/dist/vuetify.min.css";
import "./assets/scss/custom.scss";
import "./assets/css/app.main.css";
import "sweetalert2/dist/sweetalert2.min.css";

import VueApollo from "vue-apollo";
import { createApolloProvider, ApolloProvider } from "@vue/apollo-option";
import { apolloClient } from "@/utils/apollo";

const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
});

Vue.use(VueGoogleMaps, {
    load: {
        key: GOOGLE_MAP_KEY,
        libraries: "places",
    },
});

let toastOption = {
    theme: "toasted-primary",
    position: "top-right",
    duration: 3000,
    singleton: true,
    action: {
        text: "Cancel",
        onClick: (e: any, toastObject: any) => {
            toastObject.goAway(0);
        },
    },
};

Vue.mixin(socketMixin);
Vue.mixin(currentUser);
Vue.mixin(exportMixin);

Vue.use(VeeValidate, {
    fieldsBagName: "veeFields",
});
Vue.use(Toasted, toastOption);
Vue.use(Vuetify);
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.use(Antd);
Vue.use(VueApollo);
Vue.component("multiselect", Multiselect);
Vue.component("vue-tags-input", VueTagsInput);
Vue.component("downloadExcel", JsonExcel);

let user = JSON.parse(sessionStorage.getItem("userLogin") as string);
store.dispatch("auth/loginUser", user);

new Vue({
    el: "#app",
    router,
    store,
    i18n,
    apolloProvider,
    template: "<App/>",
    components: {
        App,
    },
    apollo: {},
} as any);
